Shopify.Cart = Shopify.Cart || {};
Shopify.Cart.ProductRemove = {};

var productRemovers = {}

Shopify.Cart.ProductRemove.remove = function() {
     $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: {
               updates: productRemovers
          },
          dataType: 'json',
          success: function() { location.href = '/cart'; }
     });
}

$('.item-remove-button').click(function() {
    // アラートメッセージを表示
    var confirmDelete = confirm("本当に削除しますか？");
    // ユーザーがOKを選択した場合のみ実行
    if (confirmDelete) {
        $(".item-keys").each(function () {
            var itemKey = $(this).text();
            productRemovers[itemKey] = 0;
        });
        Shopify.Cart.ProductRemove.remove();
    }
});


